// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/classes.css
// module id = 920
// module chunks = 0